"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataItem_1 = require("../common/base/DataItem");
var Field_1 = require("../../constants/Field");
var DataType_1 = require("../common/base/DataType");
var Properties = /** @class */ (function () {
    function Properties(name, version, content) {
        this.name = new DataItem_1.DataItem(Field_1.FIELD.NAME, DataType_1.DataType.string);
        this.name.value = name;
        this.name.dataType = undefined;
        this.content = new DataItem_1.DataItem(Field_1.FIELD.CONTENT, DataType_1.DataType.string);
        this.content.value = content;
        this.content.dataType = undefined;
        this.version = new DataItem_1.DataItem(Field_1.FIELD.VERSION, DataType_1.DataType.string);
        this.version.value = version;
        this.version.dataType = undefined;
    }
    Properties.prototype.updateName = function (name) {
        this.name.value = name;
    };
    Properties.prototype.updateContent = function (content) {
        this.content.value = content;
    };
    Properties.prototype.updateVersion = function (version) {
        this.version.value = version;
    };
    /**
     * Converts data to json
     */
    Properties.prototype.toJson = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.NAME] = this.name.toJson(false);
        json[Field_1.FIELD.VERSION] = this.version.toJson(false);
        json[Field_1.FIELD.CONTENT] = this.content.toJson(false);
        return json;
    };
    return Properties;
}());
exports.Properties = Properties;
//# sourceMappingURL=DraftProperties.js.map